var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10777",
    "data-name": "Grupo 10777",
    transform: "translate(-37 -480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10778",
    "data-name": "Grupo 10778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_96",
    "data-name": "Elipse 96",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(37 480)",
    fill: "#fbc343",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M23,0A23,23,0,1,1,0,23,23,23,0,0,1,23,0Z",
    transform: "translate(44 487)",
    fill: "#fbc343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bell",
    "data-name": "Icon awesome-bell",
    d: "M13.5,30.849a3.855,3.855,0,0,0,3.854-3.856H9.642A3.855,3.855,0,0,0,13.5,30.849Zm12.978-9.02c-1.164-1.251-3.342-3.132-3.342-9.3a9.515,9.515,0,0,0-7.709-9.349V1.928a1.927,1.927,0,1,0-3.854,0V3.184a9.515,9.515,0,0,0-7.709,9.349c0,6.164-2.178,8.045-3.342,9.3A1.882,1.882,0,0,0,0,23.136a1.93,1.93,0,0,0,1.934,1.928H25.058a1.929,1.929,0,0,0,1.934-1.928,1.881,1.881,0,0,0-.519-1.308Z",
    transform: "translate(54 495)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPriority);
export default __webpack_public_path__ + "static/media/bell-priority.b8efe6ea9f690b0f3fb5150750e58934.svg";
export { ForwardRef as ReactComponent };